import React, { useContext } from "react";

import { Button, Modal, ModalBody, ModalFooter, ModalHeading } from "@braze/beacon-core";

import { StackOrder } from "@lib/canvasStackOrder";

import { AsyncConfirmationModalContext } from "../AsyncConfirmationModalContext";

export const AsyncConfirmationModalWithNoIntent = (): React.ReactElement | null => {
  const { state, activeModal, handleCancel, handleOk, handleTertiary } = useContext(AsyncConfirmationModalContext);

  if (!activeModal) {
    return null;
  }

  return (
    <Modal
      className="confirmation-modal bcl-ignore-click-outside"
      isOpen={state.isOpen}
      toggle={handleCancel(activeModal.id)}
      size={activeModal.size}
      ignoreOutsideClick
      hideCloseButton
      zIndex={StackOrder.OVERLAY_CONTENT_ABOVE_POPOVER}
    >
      {activeModal.heading && <ModalHeading>{activeModal.heading}</ModalHeading>}
      <ModalBody className="confirmation-modal_body">{activeModal.body}</ModalBody>
      <ModalFooter className="confirmation-modal_footer">
        {activeModal.tertiaryText && (
          <ModalFooter aligner side="left">
            <Button
              className="confirmation-modal_tertiary-button"
              variant="tertiary"
              onClick={handleTertiary(activeModal.id)}
            >
              {activeModal.tertiaryText}
            </Button>
          </ModalFooter>
        )}
        <ModalFooter aligner side="right">
          {!activeModal.hideCancelButton && (
            <Button
              className="confirmation-modal_cancel-button"
              variant="secondary"
              onClick={handleCancel(activeModal.id)}
            >
              {activeModal.cancelText}
            </Button>
          )}
          <Button className="confirmation-modal_ok-button" variant="primary" onClick={handleOk(activeModal.id)}>
            {activeModal.okText}
          </Button>
        </ModalFooter>
      </ModalFooter>
    </Modal>
  );
};
